
import { FloatingLabel, Form, Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';

import useEscolaridades from "../hooks/useEscolaridades"
import { escolaridades } from '../data/datos';
import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';
import { Toast } from './Toast';
import { ATag } from './ATag';

const Escolaridades = () => {


    const { isOpen, abrirModal, cerrarModal, guardarEscolaridad, setFormEscolaridad,
        formEscolaridad, check, escolaridadesUsuario, borrarEscolaridad,
        llenarFormEscolaridad, cargando, procesarArchivo, url_archivos,
        pk_escolaridad,
        isOpenEditar, cerrarModalEditar,
        setCampoEditando, setValorEditando, formModal, setFormModal, preguntarTitulacion,
        cargandoActualizar, procesarArchivoEditar, actualizarEscolaridadFormulario,
        cargandoCedula, cargandoTitulo, nombreCedula, nombreTitulo, cargandoCedulaEnlace, cargandoTituloEnlace } = useEscolaridades();



    function render1() {

        // eslint-disable-next-line
        if (pk_escolaridad == 0) {
            return (
                <>
                    <Col xs={12} xl={6}>
                        <label>Debe subir su cédula</label>
                        <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1">
                            <Form.Control
                                type="file"
                                onChange={ e => procesarArchivo(e, 'cedula') }
                                accept="image/png, image/jpg, image/jpeg, .pdf"
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} xl={6}>
                        <label>Debe subir su título</label>
                        <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1">
                            <Form.Control
                                type="file"
                                onChange={ e => procesarArchivo(e, 'titulo') }
                                accept="image/png, image/jpg, image/jpeg, .pdf"
                            />
                        </Form.Group>
                    </Col>
                </>
            )
        }
    }


    // cedula
    function render2() {

        // hay archivo? ps dale
        if ( nombreCedula ) {
            return (
                <>
                    <Col xs={12} xl={6}>
                        { !cargandoCedulaEnlace
                            ? <Alert variant='success'>
                                <Alert.Link target='_blank' href={ url_archivos( nombreCedula ) }>Click aquí para ver su cédula</Alert.Link>
                            </Alert>
                            : <Spinner/>}
                    </Col>
                    <Col xs={12} xl={6}>
                        <label className='mb-1'>Si desea cambiar su cédula, presione el siguiente botón:</label>
                        { cargandoCedula
                            ? <Spinner/>
                            : <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1">
                                    <Form.Control
                                        type="file"
                                        onChange={ e => procesarArchivoEditar(e, 'cedula') }
                                        accept="image/png, image/jpg, image/jpeg, .pdf"
                                    />
                                </Form.Group>}
                    </Col>
                </>
            )

            // no hay archivo, ps agregar
        } else {
            return (
                <Col xs={12} xl={6}>
                    <label>Debe subir su cédula</label>
                    <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1 justify-content-center">
                        { cargandoCedula
                            ? <Spinner/>
                            : <Form.Control
                                type="file"
                                onChange={ e => procesarArchivoEditar(e, 'cedula') }
                                accept="image/png, image/jpg, image/jpeg, .pdf"
                            />
                        }
                    </Form.Group>
                </Col>
            )
        }
    }


    // titulo
    function render3Titulos() {

        // hay archivo? ps dale
        if ( nombreTitulo ) {
            return (
                <>
                    <Col xs={12} xl={6}>
                        { !cargandoTituloEnlace
                            ? <Alert variant='success'>
                                <Alert.Link target='_blank' href={ url_archivos( nombreTitulo ) }>Click aquí para ver su título</Alert.Link>
                            </Alert>
                            : <Spinner/> }
                    </Col>
                    <Col xs={12} xl={6}>
                        <label className='mb-1'>Si desea cambiar su título, presione el siguiente botón:</label>
                        { cargandoTitulo
                            ? <Spinner/>
                            : <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1">
                                    <Form.Control
                                        type="file"
                                        onChange={ e => procesarArchivoEditar(e, 'titulo') }
                                        accept="image/png, image/jpg, image/jpeg, .pdf"
                                    />
                                </Form.Group>}
                    </Col>
                </>
            )

            // no hay archivo, ps agregar
        } else {
            return (
                <Col xs={12} xl={6}>
                    <label>Debe subir su título</label>
                    <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1 justify-content-center">
                        { cargandoTitulo
                            ? <Spinner/>
                            : <Form.Control
                                type="file"
                                onChange={ e => procesarArchivoEditar(e, 'titulo') }
                                accept="image/png, image/jpg, image/jpeg, .pdf"
                            />
                        }
                    </Form.Group>
                </Col>
            )
        }
    }

    function enlaceTitulo( es_titulado, archivo ) {

        if (es_titulado && archivo ) {
            return <ATag link={ url_archivos( archivo ) } texto='Ver'/>
        }

        if ( es_titulado && archivo == null ) {
            return 'Archivo pendiente'
        }

        if ( es_titulado && [null, '', undefined].includes(archivo) ) {
            return 'Archivo pendiente'
        }

    }


    return (
        <div className="my-4">
            <hr className='m-5'/>
                <p className="lead text-center">
                    Escolaridades
                </p>





                <p className='mt-4 fs-5 text'>En el siguiente formulario, por favor, proporciona detalles acerca de tu formación académica, incluyendo estudios profesionales, número de cédula y título correspondiente.</p>
                <p className='mt-4 fs-5 text'>
                    <b>Nota:</b> Si cuentas con un posgrado, ya sea una maestría o doctorado, asegúrate de incluir también la información correspondiente a tu licenciatura.
                </p>
                <Alert variant='success my-4'>
                    <ul>
                        <li>Presiona el ícono <PencilIcon/> para editar un registro.</li>
                        <li>Presiona el ícono <DeleteIcon/> para eliminar un registro.</li>
                    </ul>
                </Alert>

				<Button variant="info" onClick={ abrirModal } className='mb-4'>
                    Agregar escolaridad
                </Button>

                <div className='table-responsive'>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th className='text-center'>Escolaridad</th>
                                <th className='text-center'>Carrera</th>
                                <th className='text-center'>Institución</th>
                                <th className='text-center'>¿Está titulado?</th>
                                <th className='text-center'>Cédula</th>
                                <th className='text-center'>Título</th>
                                <th className='text-center'>Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            { escolaridadesUsuario.map(( e, i )=> (
                                <tr key={ i }>
                                    <td className='text-center'>
                                        { e.escolaridad }
                                    </td>
                                    <td className='text-center'>
                                        { e.carrera }
                                    </td>
                                    <td className='text-center'>
                                        { e.escuela }
                                    </td>
                                    <td className='text-center'>
                                        {/* eslint-disable-next-line */}
                                        { ( e.es_titulado == '1' ) ? "Si" : "No" }
                                    </td>
                                    <td className='text-center'>
                                        {/* { e.es_titulado ? <ATag link={ url_archivos( e.archivo_cedula ) } texto={e.cedula}/> : '' } */}
                                        { enlaceTitulo(e.es_titulado, e.archivo_cedula) }
                                    </td>
                                    <td className='text-center'>
                                        {/* { e.es_titulado ? <ATag link={ url_archivos( e.archivo_cedula ) } texto={e.cedula}/> : '' } */}
                                        { enlaceTitulo(e.es_titulado, e.archivo_titulo) }
                                    </td>
                                    <td>
                                        <ButtonGroup>
                                            <TooltipHover tooltipText='Editar información'>
                                                <Button variant='warning' onClick={ () => llenarFormEscolaridad( e ) }>
                                                    <PencilIcon/>
                                                </Button>
                                            </TooltipHover>
                                            <TooltipHover tooltipText='Eliminar escolaridad'>
                                                <Button variant='danger' onClick={ () => borrarEscolaridad( e.pk_escolaridad, e.archivo_cedula, e.archivo_titulo ) }>
                                                    <DeleteIcon/>
                                                </Button>
                                            </TooltipHover>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>




                {/* modal para registrar cosa */}
                <Modal
                    show={ isOpen }
                    onHide={ cerrarModal }
                    backdrop="static"
                    keyboard={false}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    className=''
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Administrar escolaridades</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Alert variant='success' className='text-center'>
                            Completa los siguientes campos para registrar tu escolaridad
                        </Alert>

                        <Row>
                            <Col xs={12} xl={6}>
                                <FloatingLabel controlId="floatingSelect" label="Escolaridad" className='mb-3'>
                                    <Form.Select
                                        aria-label=" "
                                        value={ formEscolaridad.escolaridad }
                                        onChange={ e => setFormEscolaridad({ ...formEscolaridad, escolaridad: e.target.value }) }
                                    >
                                        { escolaridades.map( e => <option value={ e } key={ e }>{ e }</option> ) }
                                    </Form.Select>
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput1"
                                    label="Carrera"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formEscolaridad.carrera }
                                        onChange={ e => setFormEscolaridad({ ...formEscolaridad, carrera: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput2"
                                    label="Institución"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formEscolaridad.institucion }
                                        onChange={ e => setFormEscolaridad({ ...formEscolaridad, institucion: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6} className='d-flex align-items-center'>
                                <Form.Check
                                    type="checkbox"
                                    id='es_titulado'
                                    onChange={ check }
                                    className='no-select'
                                    checked={ formEscolaridad.titulado }
                                    label="Marcar en caso de estar titulado"
                                />
                            </Col>
                            {/* eslint-disable-next-line */}
                            { formEscolaridad.titulado == 1 ? (
                                <>
                                    <Col xs={12} xl={6}>
                                        <FloatingLabel
                                            controlId="floatingInput3"
                                            label="Cédula"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                placeholder=" "
                                                autoComplete='off'
                                                value={ formEscolaridad?.cedula ?? '' }
                                                onChange={ e => setFormEscolaridad({ ...formEscolaridad, cedula: e.target.value }) }
                                            />
                                        </FloatingLabel>
                                    </Col>
                                    {/* <Col xs={12} xl={6}> */}
                                        { render1() }
                                    {/* </Col> */}
                                </>
                            ) : ''}
                        </Row>

                        {/* aquí abajo iban las escolaridades */}

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={ cerrarModal }>
                            Cerrar
                        </Button>
                        <Button variant="primary" onClick={ guardarEscolaridad } disabled={ cargando }>
                            { ( cargando ) ? "Guardando" : "Guardar cambios" }
                        </Button>
                    </Modal.Footer>
                </Modal>


                {/* modal para editar */}
                <Modal
                    show={ isOpenEditar }
                    onHide={ cerrarModalEditar }
                    backdrop="static"
                    keyboard={false}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    className=''
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Actualizar información</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        {/* <Alert variant='info'>
                            La información se guardará automáticamente mientras escribe.
                        </Alert> */}

                        <Row>
                            <Col xs={12} xl={6}>
                                <FloatingLabel controlId="floatingSelect2" label="Escolaridad" className='mb-3'>
                                    <Form.Select
                                        aria-label=" "
                                        value={ formModal.escolaridad }
                                        onChange={ e => {
                                            setFormModal({ ...formModal, escolaridad: e.target.value })
                                            setCampoEditando('escolaridad')
                                            setValorEditando(e.target.value)
                                        }}
                                    >
                                        { escolaridades.map( e => <option value={ e } key={ e }>{ e }</option> ) }
                                    </Form.Select>
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput12"
                                    label="Carrera"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formModal.carrera }
                                        onChange={ e => {
                                            setFormModal({ ...formModal, carrera: e.target.value })
                                            setCampoEditando('carrera')
                                            setValorEditando(e.target.value)
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput22"
                                    label="Institución"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formModal.escuela }
                                        onChange={ e => {
                                            setFormModal({ ...formModal, escuela: e.target.value })
                                            setCampoEditando('escuela')
                                            setValorEditando(e.target.value)
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6} className='d-flex align-items-center'>
                                <Form.Check
                                    type="checkbox"
                                    id='es_titulado'
                                    onChange={ e => preguntarTitulacion( e.target.checked )}
                                    className='no-select'
                                    checked={ formModal.titulado }
                                    label="Marcar en caso de estar titulado"
                                />
                            </Col>
                            {/* eslint-disable-next-line */}
                            { formModal.titulado == 1 ? (
                                <>
                                    <Col xs={12} xl={6}>
                                        <FloatingLabel
                                            controlId="floatingInput32"
                                            label="Cédula"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                placeholder=" "
                                                autoComplete='off'
                                                value={ formModal?.cedula ?? '' }
                                                onChange={ e => {
                                                    setFormModal({ ...formModal, cedula: e.target.value })
                                                    setCampoEditando('cedula')
                                                    setValorEditando(e.target.value)
                                                }}
                                            />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={12} xl={6}></Col>
                                    <Row className='mt-3'>
                                        { render2() }
                                    </Row>
                                    <Row className='mt-3'>
                                        { render3Titulos() }
                                    </Row>
                                    {/* <Col xs={12} xl={6}>
                                    </Col> */}
                                </>
                            ) : ''}
                        </Row>

                        {/* aquí abajo iban las escolaridades */}

                    </Modal.Body>

                    <Modal.Footer className='d-flex justify-content-between'>
                        <div></div>
                        { cargandoActualizar && <Spinner/> }
                        <div>
                            <Button variant="secondary" onClick={ cerrarModalEditar }>
                                Cerrar
                            </Button>
                            &nbsp;
                            <Button variant="primary" onClick={ actualizarEscolaridadFormulario } disabled={ cargando }>
                                { ( cargando ) ? "Guardando" : "Guardar cambios" }
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>

            <hr className='m-5'/>
            <Toast texto='Error al traer tus escolaridades. Puedes revisar tu conexión o iniciar sesión nuevamente.'/>
        </div>
    )
}

export default Escolaridades
